import { render } from "./ProfilePrice.vue?vue&type=template&id=7adf4251&ts=true"
import script from "./ProfilePrice.vue?vue&type=script&lang=ts"
export * from "./ProfilePrice.vue?vue&type=script&lang=ts"

import "./ProfilePrice.vue?vue&type=style&index=0&id=7adf4251&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__